import Cookies from 'js-cookie'
import { title } from '@base/settings'

//获取cookie
export const getCookie = (name) => {
  return Cookies.get(name)
}

//设置cookie
export const setCookie = (name, value) => {
  return Cookies.set(name, value)
}

//删除cookie
export const removeCookie = (name) => {
  return Cookies.remove(name)
}

//获取sessionStorage
export const getStorage = key => {
  return window.sessionStorage.getItem(key) || undefined
}

//设置sessionStorage
export const setStorage = (key, value) => {
  if (key && value) {
    window.sessionStorage.setItem(key, value)
  }
}

//删除sessionStorage
export const removeStorage = key => {
  if (key) {
    window.sessionStorage.removeItem(key)
  }
}

//Loading配置
export const LoadingOptions = {
  fullscreen: true,
  lock: true,
  text: "正在加载，请稍后...",
  background: 'rgba(0,0,0,.7)'
}

//设置页面title
export const setPageTitle = (str) => {
  return `${ str || title } - 机考模拟系统`
}

//判断是否是空对象
export const isEmptyObject = (obj) => Object.keys(obj).length <= 0

//字符串转换数字
export const parseNumber = (str) => {
  if (!str) return ''
  return parseInt(str)
}

// 时间转换 createTime
export const timestampToTime = (timestamp) => {
  let date = new Date(timestamp || new Date())// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
 export const formatTime = (time, cFormat) => {
  if (time.length === 0) return null
  if (time === null) return null

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
      date = time
  } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
          time = parseInt(time)
      }
      if (typeof time === 'number' && time.toString().length === 10) {
          time = time * 1000
      }
      date = new Date(time)
  }
  const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
          value = '0' + value
      }
      return value || 0
  })
  return time_str
}

//  秒转换为分钟格式
export const secondsToMinutes = (spendTime) => {
  let minutes = Math.floor(spendTime / 60)
  let seconds = spendTime % 60
  return minutes + '分' + seconds + '秒'
}

//深拷贝
export const deepCopy = (obj) => {  //  深拷贝引用类型变量
  let result = Array.isArray(obj) ? [] : {};
  if(typeof result === 'object') {
    for (let key in obj) {
      // eslint禁止检查hasOwnProperty或使用Object.prototype.hasOwnProperty.call(obj, key);
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        if ((obj[key]) instanceof Object) {
          result[key] = deepCopy(obj[key]);   //递归复制
        } else {
          result[key] = obj[key];
        }
      }
    }
  } else {
    for(let item of obj) {
      if ((item) instanceof Object) {
        result.push(deepCopy(obj[item]));   //递归复制
      } else {
        result.push(obj[item]);
      }
    }
  }
  return result;
}

//大题排序
export const sortTheme = (a, b) => {
  let sortArr = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
  let aIndex = sortArr.indexOf(a['showSerialNum'])
  let bIndex = sortArr.indexOf(b['showSerialNum'])
  return aIndex - bIndex
}
// html转化为纯文本 去掉标签空格回车换行
export const removeHTMLTag = (html) => {
  if(html){
    return html.replace(/<[^>]+>|\s+|\t|\r|\n|&nbsp;/g, '')
  }
  return ''
}
// 对象数组去重
export const uniqueObjArr = (arr = [], key) => {
  if (arr && arr.length > 0) {
    const keyVals = new Set()
    return arr.filter((obj) => {
      const val = obj[key]
      if (keyVals.has(val)) return false
      keyVals.add(val)
      return true
    })
  }
}


